var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-100",attrs:{"id":"app"}},[_c(_vm.layout,{tag:"component"},[_c('router-view')],1),(_vm.$route.name != 'Tickets')?_c('support'):_vm._e(),_c('scroll-to-top')],1)}
var staticRenderFns = []

export { render, staticRenderFns }